import { useEffect, useState } from "react";
import { useApi } from "../useApi";
import { isErr } from "../../Utils/Result";

export interface PlatformConfig {
  chatSseEnabled: boolean;
}

const DEFAULT_CONFIG: PlatformConfig = { chatSseEnabled: false };

export const usePlatformConfig = (): PlatformConfig => {
  const { getPlatformConfigEndpoint } = useApi();
  const [config, setConfig] = useState<PlatformConfig>(DEFAULT_CONFIG);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const response = await getPlatformConfigEndpoint();
      if (cancelled) return;
      if (isErr(response)) return; // keep failsafe default
      setConfig(response.value);
    })();
    return () => {
      cancelled = true;
    };
  }, [getPlatformConfigEndpoint]);

  return config;
};
